import React from "react";
import { NavLink } from "react-router-dom"
import { connect } from 'react-redux';

import {
  loadProjects, saveProjectID,
} from 'actions/MyProjects';

import {
  loadFolders, saveFolderID,
} from 'actions/MyFolders';

function PropertiesItemCard({ props, data }) {
  const { customer, endDate, generalContractor, myRole, name, note, startDate, key } = data;

  return (
    <div className="media jr-featured-item">
      <div className="media-body jr-featured-content">
        <div className="jr-featured-content-left">

          <span className="jr-tag text-uppercase bg-info d-inline-block" color="#06BB8A">In Corso</span>
          <h3 className="mb-1">{name}</h3>

          <p className="text-grey mb-1">{note}</p>

          <div className="d-flex flex-row">
            <p className="text-grey mb-1">
              <i className={`zmdi zmdi-account jr-fs-lg mr-2 d-inline-block align-middle`} />{customer}
            </p>
            <p className="text-grey ml-4 mb-1">
              <i className={`zmdi zmdi-calendar-alt jr-fs-lg mr-2 d-inline-block align-middle`} />{startDate} - {endDate}
            </p>
          </div>
        </div>
        <div className="jr-featured-content-right">
          <div>
            <h2 className="mb-0 jr-font-weight-medium">{generalContractor}</h2>
            <p className="text-grey jr-fs-sm">{myRole}</p>
          </div>
          <p onClick={() => {

            localStorage.setItem('project_id', key);
            props.saveProjectID(key);

          }} className="text-primary mt-auto mb-0 pointer"><span><NavLink to="/app/folders">Seleziona</NavLink></span> <i
              className={`zmdi zmdi-long-arrow-right jr-fs-xxl ml-2 d-inline-block align-middle`} /></p>
        </div>

      </div>
    </div>
  );
}

export default connect('', {
  loadProjects,
  saveFolderID,
})(PropertiesItemCard);
